import { Icon } from '@iconify/react/dist/iconify.js'
import React, { useEffect } from 'react'
import AOS from 'aos'; // Import AOS library

function Blog() {
     // Initialize AOS when the component mounts
     useEffect(() => {
      AOS.init({
        duration: 1000, // Animation duration in milliseconds
        once: true, // Whether animation should happen only once while scrolling down
      });
    }, []);
    return (
        <div className='flex justify-center flex-col items-center w-full md:h-dvh h-full bg-[#080808]' style={{ fontFamily: 'Ropa sans' }}>
            <div className='flex justify-start w-10/12 pt-10 mb-5'><h1 className='font-bold text-xl text-gray-200' style={{ fontFamily: 'Chakra Petch' }}>Blogs</h1></div>

            <div className='flex md:flex-row flex-col justify-center md:w-11/12 w-full h-full gap-10'>
                <div data-aos="zoom-in-up" className='flex flex-col items-center md:w-6/12 w-full h-5/6 justify-start'>
               <div className='flex w-11/12 h-4/6 pt-5'> <img className='w-full h-full rounded-lg' src="https://invotech.co/blog/wp-content/uploads/2021/05/Top-Front-End-Trends-In-2021@1x.jpg" alt="" /></div>
               <div className='flex w-11/12'>
               <h2 className='text-gray-200 font-bold text-xl mt-2' style={{ fontFamily: 'Chakra Petch' }}>Modern Front-End Development: Trends & Techniques</h2>
               </div>
               <div className='flex w-11/12'>
               <h2 className='text-gray-400 mt-2'>Front-end is actually what people see and interact with, hence, it becomes very important for you as a front-end developer to keep the user experience smooth. Front-end developers always look for trends that emerge as modernization happens. As a front-end developer, you need to keep up with the trends and technologies fellow developers follow. You need to always question yourself on what is the emerging trend for front-end development which could make your front-end look appealing to the users.</h2>
               </div>
               <div className='w-11/12 text-gray-600 flex flex-row gap-1 items-center hover:text-blue-500 hover:scale-y-105'>
              <span>Read more</span>
              <Icon icon='heroicons:arrow-top-right-on-square-16-solid' />
            </div>
                </div>
                
                {/* blog 1 */}
                <div className='flex flex-col items-center md:w-5/12 w-full h-5/6 gap-3 justify-center'>
                <div className='flex justify-start w-11/12 pb-2'><h1 className='font-bold text-xl text-indigo-400 underline' style={{ fontFamily: 'Chakra Petch' }}>Spotlight</h1></div>
                <div data-aos="zoom-in-up" className='w-11/12 h-1/4 flex flex-row items-center'>
                <div className='w-8/12 flex flex-col justify-start'>
                <span className='text-gray-200 ' style={{ fontFamily: 'Chakra Petch' }}>Enhancing User Experience with Micro-Interactions</span>
                <span className='pt-2 text-sm text-gray-400'>Micro-interactions are subtle animations or responses to user input that enhance the overall experience of your app. These little details are what turn a good interface into a delightful one. With tools like Framer Motion and GSAP.</span>
                <div className='w-11/12 text-gray-600 flex flex-row gap-1 items-center hover:text-blue-500 hover:scale-y-105'>
              <span>Read more</span>
              <Icon icon='heroicons:arrow-top-right-on-square-16-solid' />
            </div>
                </div>
                <div className='w-4/12 h-full'>
                <img className='w-full h-full object-cover' src="https://cdn.icon-icons.com/icons2/1881/PNG/512/iconfinder-mobile-seo-4341271_120582.png" alt="" />
                </div>
                </div>

                <div className='h-[1px] w-11/12 bg-gray-100 my-1'></div>

                <div data-aos="zoom-in-up" className='w-11/12 h-1/4 flex flex-row items-center'>
                <div className='w-8/12 flex flex-col justify-start'>
                <span className='text-gray-200' style={{ fontFamily: 'Chakra Petch' }}>The Importance of Web Accessibility in 2024</span>
                <span className='pt-2 text-sm text-gray-400'>Building an accessible web is more important than ever. With a growing emphasis on inclusivity, web accessibility (a11y) ensures that everyone, including people with disabilities, can interact with your website or application.This is one of the important thing most of the techies avoiding.</span>
                <div className='w-11/12 text-gray-600 flex flex-row gap-1 items-center hover:text-blue-500 hover:scale-y-105'>
              <span>Read more</span>
              <Icon icon='heroicons:arrow-top-right-on-square-16-solid' />
            </div>
                </div>
                <div className='w-4/12 h-full'>
                <img className='w-full h-full object-cover' src="https://cdni.iconscout.com/illustration/premium/thumb/students-attending-online-classes-2749775-2294225.png" alt="" />
                </div>
                </div>

                <div className='h-[1px] w-11/12 bg-gray-100 my-1'></div>

                <div data-aos="zoom-in-up" className='w-11/12 h-1/4 flex flex-row items-center'>
                <div className='w-8/12 flex flex-col justify-start'>
                <span className='text-gray-200' style={{ fontFamily: 'Chakra Petch' }}>Tailwind CSS:It's Revolutionizing Front-End Development</span>
                <span className='pt-2 text-sm text-gray-400'>In the world of front-end development, we are constantly looking for tools and frameworks that can simplify our workflow while maintaining flexibility and customization. Tailwind CSS has emerged as one of the most popular utility-first CSS frameworks.</span>
                <div className='w-11/12 text-gray-600 flex flex-row gap-1 items-center hover:text-blue-500 hover:scale-y-105'>
              <span>Read more</span>
              <Icon icon='heroicons:arrow-top-right-on-square-16-solid' />
            </div>
                </div>
                <div className='w-4/12 h-full'>
                <img className='w-full h-full object-cover' src="https://vueschool.io/storage/media/4dd76198cbda1723cb90783884acf608/Tailwind-CSS-01-(1).png" alt="" />
                </div>
                </div>

                <div className='h-[1px] w-11/12 bg-gray-100 my-1'></div>

                </div>

            </div>
        </div>
    )
}

export default Blog